<template>
  <div>
    <breadcrumbs :home="name"/>

    <purtrak-table name="maintenance" objectType="log entries" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   :listEndPoint="getListData" fields="" totalField=""
                   :listFilters="listFilters"
                   :title="name"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'']}"
                   :download-endpoint="exportListData">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.from=null;filters.to=null">
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
        </template>
      </template>
      <template v-slot:item.date="{value}">
        {{value | formatDate}}
      </template>
      <template v-slot:item.notes="{value,printing}">
        <template v-if="printing">{{value}}</template>
        <div v-else class="text-caption">{{value}}</div>
      </template>
    </purtrak-table>
  </div>
</template>

<script>

export default {
  name: 'EquipmentMaintenanceLog',
  props: {
    equipmentId: {type:String, required:true}
  },
  data() {
    return {
      name: '',
      filters: {
        from: null,
        to: null
      },
      dateDisplay: '',
      equipment: {name:''},
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'userName', visible:true},
                       { value: 'notes', visible:true}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: 'USER', value: 'userName', width:'15%',sortable:true},
                { text: 'NOTES', value: 'notes', width:'70%',sortable:false}]

    }
  },
  computed: {
    listFilters() {
      const filters = [];
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      return filters;
    }
  },
  methods: {
    async getListData(after, cursor, pageSize, filters, parameters, options) {
      const results = await this.$apiCall(`query EquipmentMaintenanceLog($id:ID!, $after: String, $first:Int, $before: String, $last: Int, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                             equipment(id:$id) {
                                                name
                                                maintenanceLog(first:$first, after:$after, last:$last, before:$before, filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters) {
                                                  totalCount
                                                  pageInfo {
                                                    hasPreviousPage
                                                    hasNextPage
                                                    startCursor
                                                    endCursor
                                                  }
                                                  edges {
                                                    cursor
                                                    node {
                                                      date,notes,userName
                                                    }
                                                  }
                                                }
                                              }
                                            }`,
                                           {id:this.equipmentId,
                                            after:after?cursor:null, first:after?pageSize:null,
                                            before:!after?cursor:null, last:!after?pageSize:null,
                                            filters, parameters,
                                            sortKey:options.sortBy[0], reverse:options.sortDesc[0]});

      const equipment = results.data.equipment;
      this.name = `${equipment.name}: Maintenance log`;
      return equipment.maintenanceLog;
    },
    async exportListData(filters, parameters, options) {
      const results = await this.$apiCall(`query EquipmentMaintenanceLog($id:ID!, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                              equipment(id:$id) {
                                                maintenanceLogExportCSV(filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters)
                                              }
                                            }`,
                                          {id:this.equipmentId,
                                          filters, parameters,
                                           sortKey:options.sortBy[0], reverse:options.sortDesc[0]});
      if (!results.error)
        return results.data.equipment.maintenanceLogExportCSV;
    }
  }
}
</script>